import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { renderAutoCompleteSingleSelect } from '../../../../components/reduxFields';
import { getMasterData, updateClaimDetails } from './actions/ManageClaimActions';
import FlatButton from 'material-ui/FlatButton';
import validate from './ValidateClaim';

class ClaimModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      masterPractitionerList: props.master_data ? props.master_data.allStaffs : [],
      masterRenderingProviderList: props.master_data ? props.master_data.allStaffs : [],    
      masterPatientLocation: props.master_data ? props.master_data.masterPatientLocation : [],    
      ClaimData: props.ClaimData,
      ClaimId: props.ClaimId,
      //serviceTypes: [{ 'id': 11, 'value': 'Office' }, { 'id': 12, 'value': 'Home' }],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      let masterData = nextProps.master_data;
      this.setState({
        masterPractitionerList: masterData.allStaffs,
        masterRenderingProviderList: masterData.allStaffs,
        masterPatientLocation: masterData.masterPatientLocation,
      });
    }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

    handleNewRequest = (input, selectedRecord) => {
      input.onChange(selectedRecord.value);
    }
    handleClose = () => {
      if (this.state.open) {
        this.setState({ open: false });
        this.props.closeDialog();
      }
    };

    onSubmitHandler(formData) {
      this.props.updateClaimDetails(formData, this.props.ClaimId);
      this.setState({ open: false });
      this.props.closeDialog();
    }

    render() {
      const { handleSubmit } = this.props;
     // const { serviceTypes } = this.state;
      return (
        <Dialog className="custom_modal"
          title={'Edit Claim CL' + this.props.ClaimId}
          modal={false}
          open={this.state.open}
          autoScrollBodyContent={true}>

          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
                <div className="row">
                  <div className="col-sm-6 require mt-35">
                    <Field
                      name="clinicianId"
                      label="Practitioner"
                      handleNewRequest={this.handleNewRequest}
                      options={this.state.masterPractitionerList}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>
                  <div className="col-sm-6 require mt-35">
                    <Field
                      name="renderingProviderId"
                      label="Rendering Provider"
                      handleNewRequest={this.handleNewRequest}
                      options={this.state.masterRenderingProviderList}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6 require mt-35">
                    <Field
                      name="serviceLocationId"
                      label="Service Location"
                      handleNewRequest={this.handleNewRequest}
                      options={this.state.masterPatientLocation}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>
                  <div className="col-sm-6 pt20 btn_rt">
                    <FlatButton className="grey_btn"
                      label="Cancel" onTouchTap={this.handleClose} />
                    <FlatButton className="blue_btn"
                      label="Save" primary={true} type='submit'/>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Dialog>
      );
    };
}

function mapStateToProps(state, ownprops) {
  return {
    master_data: state.billing.master_data,
    initialValues: state.billing.claimData ? state.billing.claimData.data : {},
    ClaimId: ownprops.ClaimId,
  };
}

ClaimModal = reduxForm({
  form: 'ClaimModal',
  validate,
  enableReinitialize: true,
})(ClaimModal);

export default connect(mapStateToProps, { getMasterData, updateClaimDetails })(ClaimModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/Claim_Modal.js